import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ImprovedWorkoutCreator from './workout/ImprovedWorkoutCreator';
import { debugLog } from '../../utils/logger';

/**
 * Adapter component to bridge between the existing app and the new ImprovedWorkoutCreator
 * This component maintains compatibility with the current app structure while
 * implementing the modern UI for workout creation/editing
 */
const WorkoutManagerAdapter = ({ 
  user, 
  onClose, 
  onSuccess, 
  mode = 'new', 
  initialWorkout = null 
}) => {
  const { getAuthenticatedApi } = useAuth();
  const api = getAuthenticatedApi();
  const [availableExercises, setAvailableExercises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Debug logging
  //debugLog("WorkoutManagerAdapter - props:", { mode, initialWorkout });

  // Fetch available exercises on component mount
  useEffect(() => {
    //debugLog("WorkoutManagerAdapter - initialWorkout:", initialWorkout);
    
    const fetchExercises = async () => {
      try {
        setLoading(true);
        const response = await api.get('/esercizi.php');
        if (response.data) {
          setAvailableExercises(response.data);
        }
      } catch (err) {
        console.error('Error fetching exercises:', err);
        setError('Errore nel caricamento degli esercizi. Riprova più tardi.');
      } finally {
        setLoading(false);
      }
    };

    fetchExercises();
  }, [api]);

  // Handle success callback
  const handleSuccess = (data) => {
    //debugLog("WorkoutManagerAdapter - handleSuccess:", data);
    if (onSuccess) {
      onSuccess(data);
    }
  };

  return (
    <ImprovedWorkoutCreator
      user={user}
      onClose={onClose}
      onSuccess={handleSuccess}
      mode={mode}
      initialWorkout={initialWorkout}
      availableExercises={availableExercises}
      api={api}
    />
  );
};

export default WorkoutManagerAdapter;